/** Re-signs on every click behind the session's read gate: this never expires. */
export function deliverableDownloadPath(
  sessionId: string,
  pathname: string,
  options?: { inline?: boolean },
): string {
  const query = new URLSearchParams({ pathname });
  if (options?.inline) {
    query.set("disposition", "inline");
  }
  return `/api/sessions/${sessionId}/deliverables?${query.toString()}`;
}
